/* eslint no-useless-escape: 0 */

module.exports = {
  payerAuthCheckSvcEnabled: true,
  addressFormat: 'addressLine1,addressLine2,city,state,postalCode',
  products: [
    {
      id: '1',
      refId: '1',
      name: 'Online',
      isShippingAddressRequired: false,
      st: 'DIGITAL',
    },
    {
      id: '2',
      refId: '2',
      name: 'Meetings',
      isShippingAddressRequired: true,
      st: 'WORKSHOP,STUDIO',
    },
    {
      id: '8',
      refId: '1',
      name: 'eTools',
      isShippingAddressRequired: false,
    },
    {
      id: '14',
      refId: '1',
      name: 'Online iTunes',
      isShippingAddressRequired: false,
    },
    {
      id: '22',
      refId: '0',
      name: 'Virtual Group Coaching + Digital',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
    },
    {
      id: '23',
      refId: '0',
      name: 'Virtual Community',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
      st: 'VIRTUAL_COMMUNITY',
    },
    {
      id: '24',
      refId: '0',
      name: 'Virtual Community + Workshop',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
      st: 'WORKSHOP_VIRTUAL_COMMUNITY',
    },
    {
      id: '25',
      refId: '0',
      name: 'Digital360 iTunes',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
    },
    {
      id: '27',
      refId: '0',
      name: 'Digital360 Android',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
    },
  ],
  validations: {
    firstName: {},
    lastName: {},
    addressLine1: {
      regex: "^[A-Za-z0-9\\. /\\-',#]*[A-Za-z]+[A-Za-z0-9\\. /\\-',#]*$",
    },
    addressLine2: {
      regex: "^$|^[A-Za-z0-9\\. /\\-',#]*[A-Za-z]+[A-Za-z0-9\\. /\\-',#]*$",
    },
    city: {
      regex: '^[a-zA-Z-. ]*[a-zA-Z]+[a-zA-Z-. ]*$',
    },
    postalCode: {
      type: 'string',
      min: 3,
      max: 8,
      regex:
        '^[A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]?[ ]?[0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2}$|[aA]{2}9{2}[ ][aA]{2}',
      regexFlags: '',
    },
    state: {
      required: true,
    },
    ccNumber: {
      min: 8,
      max: 20,
    },
    ccCVVNo: {},
  },
  payment: {
    modes: ['FLEX', 'CC', 'PP'],
    supportedCCs: [
      { id: 1, tid: 21, name: 'VISA', ccName: 'VISA' },
      { id: 2, tid: 22, name: 'MASTERCARD', ccName: 'MASTER CARD' },
      { id: 3, tid: 23, name: 'AMERICAN EXPRESS', ccName: 'AMERICAN EXPRESS' },
      { id: 15, tid: 26, name: 'MAESTRO', ccName: 'MAESTRO' },
    ],
  },
};
